<template>
    <div class="ls-navbar--container" test-id="container">
        <RouterLink :to="{ name: name ? 'customerSearch' : 'login' }" test-id="logo">
            <LsLogo />
        </RouterLink>
        <div v-if="name" class="ls-navbar--controls-right" test-id="right-controls">
            <LsButton
                v-if="$route.meta.oldAdminWithOutAuth"
                text="Old Admin"
                class="ls-navbar--button"
                track-id="ls_navbar-old_admin"
                test-id="button"
                @click="goToOldAdmin"
            />
            <div class="ls-navbar--name-wrapper">
                <p>
                    Hi, <span class="ls-navbar--name">{{ name }}</span>
                </p>
            </div>
            <div class="ls-navbar--avatar-container" test-id="user-icon" @click="toggleUserMenu">
                <LsIcon size="xlg" type="user" color="secondary" />
            </div>
        </div>
        <div v-if="showUserMenu" v-on-clickaway="closeUserMenu" class="ls-navbar--user-menu">
            <p class="ls-navbar--menu-link" test-id="logout-link" @click="logout">Logout</p>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsHelpers } from '@/helpers';
import { LsButton, LsIcon } from '@/components/common';
import LsLogo from '@/assets/LsLogo/LsLogo.vue';

export default {
    name: 'LsNavbar',
    components: {
        LsLogo,
        LsButton,
        LsIcon,
    },
    mixins: [clickaway],
    props: {
        user: VueTypes.shape({
            id: VueTypes.string,
            email: VueTypes.string,
            first_name: VueTypes.string,
        }).loose,
    },
    data() {
        return {
            showUserMenu: false,
        };
    },
    computed: {
        name() {
            return _.get(this.user, 'first_name');
        },
    },
    methods: {
        toggleUserMenu() {
            this.showUserMenu = !this.showUserMenu;
        },
        closeUserMenu() {
            this.showUserMenu = false;
        },
        goToOldAdmin() {
            window.location.assign(
                `${process.env.VUE_APP_ADMIN_BASE_URL}/${this.$route.meta.oldAdminWithOutAuth}`
            );
        },
        logout() {
            lsHelpers.logout();
            this.closeUserMenu();
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-navbar--container {
    background-color: $white;
    position: fixed;
    top: 0;
    left: 0;
    z-index: $z-index-navbar;
    padding: 23px 20px;
    height: $navbar-height;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 1px 15px 0 rgba(69, 65, 78, 0.1);
}

.ls-navbar--controls-right {
    position: relative;
    display: flex;
    justify-content: space-between;
}

.ls-navbar--button {
    margin-right: 30px;
}

.ls-navbar--name-wrapper {
    min-width: 70px;
    display: flex;
    align-items: center;
}

.ls-navbar--name {
    color: $secondary;
}

.ls-navbar--avatar-container {
    cursor: pointer;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    background: $primary-light;
    display: flex;
    justify-content: center;
    align-items: center;
}

.ls-navbar--user-menu {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 70px;
    right: 20px;
    width: 280px;
    border-radius: $border-radius;
    background-color: $white;
    box-shadow: 0 -15px 15px 0 rgba(69, 65, 78, 0.08);
    &:after {
        border-bottom: 10px solid $white;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        content: '';
        height: 0;
        position: absolute;
        right: 10px;
        top: -10px;
    }
}

.ls-navbar--menu-link {
    cursor: pointer;
    &:hover {
        opacity: $hover-opacity;
        user-select: none;
    }
    padding: 10px;
    margin: 10px;
}
</style>
